<template>
  <div class="table_div">
    <el-form :inline="true" class="select_form">
      <el-form-item>
        <h3>账号管理</h3>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="checkRoleDifined">分配角色</el-button>
        <el-button type="info" @click="handleResetPwd">密码重置</el-button>
        <el-button type="info" @click="handleEditUserN">登录名修改</el-button>
        <el-button type="info" @click="handleOpenRegis">企业注册</el-button>
      </el-form-item>
      <el-form-item>
        <el-input
          v-model="infoData.searchInput"
          placeholder="请输入名称"
          clearable
          @clear="getTableData"
        >
          <template #append>
            <el-button icon="Search" @click="getTableData" />
          </template>
        </el-input>
      </el-form-item>
    </el-form>
    <el-table
      :data="infoData.tableData"
      stripe
      border
      @select="handleSelect"
      ref="tableData"
      @current-change="handleTableChange"
      highlight-current-row
      table-layout="fixed"
      v-loading="infoData.loading"
      height="90%"
    >
      <el-table-column type="selection" width="55" />
      <el-table-column label="状态" width="100">
        <template #default="scope">
          <el-tag v-if="scope.row.userStatus == 1" type="success">正常</el-tag>
          <el-tag v-else-if="scope.row.userStatus == 0">待审核</el-tag>
          <el-tag v-else-if="scope.row.userStatus == 3" type="info"
            >停用</el-tag
          >
          <el-tag v-else-if="scope.row.userStatus == 2" type="danger"
            >审核不通过</el-tag
          >
          <el-tag v-else-if="scope.row.userStatus == 5" type="danger"
            >已删除</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column prop="nickName" label="名称" />
      <el-table-column prop="loginName" label="登录名" />
      <el-table-column prop="passWord" label="密码" />
      <el-table-column prop="orgCode" label="信用代码" />
      <el-table-column prop="registFromSys" label="注册来源" />
      <el-table-column label="操作">
        <template #default="scope">
          <el-switch
            v-model="scope.row.userStatus"
            :active-value="1"
            :inactive-value="3"
            active-text="启用"
            inactive-text="停用"
            size="small"
            style="
              --el-switch-on-color: #13ce66;
              --el-switch-off-color: #ff4949;
            "
            @change="handleSwithSta(scope.row.id, scope.row.userStatus)"
          />
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="infoData.pageInfo.pageIndex"
      :page-sizes="[20, 50, 100, 200, 500, 1000]"
      :page-size="infoData.pageInfo.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="infoData.pageInfo.totalRowCount"
      v-if="infoData.pageInfo.totalRowCount"
      class="pageinfo"
    >
    </el-pagination>
    <el-dialog v-model="infoData.dialogVisible" title="修改用户名" width="40%">
      <el-form :inline="true" label-position="left" label-width="70px">
        <el-form-item label="原用户名">
          <el-input v-model="infoData.oldLoginName" clearable />
        </el-form-item>
        <el-form-item label="新用户名">
          <el-input v-model="infoData.newLoginName" clearable />
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="infoData.dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="handleResetUserName"
            >确定</el-button
          >
        </span>
      </template>
    </el-dialog>
    <el-dialog
      v-model="infoData.regisDialogVisible"
      title="企业注册"
      width="30%"
    >
      <el-form label-position="left" label-width="70px" v-model="infoData.form">
        <el-form-item label="登录名">
          <el-input v-model="infoData.form.loginName" clearable />
        </el-form-item>
        <el-form-item label="企业名称">
          <el-input v-model="infoData.form.name" clearable />
        </el-form-item>
        <el-form-item label="信用代码">
          <el-input v-model="infoData.form.orgCode" clearable />
        </el-form-item>
        <el-form-item label="密码">
          <el-input v-model="infoData.form.passWord" clearable />
        </el-form-item>
        <el-form-item label="联系电话">
          <el-input
            v-model="infoData.form.tel"
            clearable
            placehoder="找回密码的手机号码"
          />
        </el-form-item>
        <el-form-item label="行政区域">
          <el-cascader
            placeholder="请选择行政区划"
            filterable
            style="width: 100%"
            :options="infoData.regionDataList"
            v-model="infoData.form.regionId"
            :props="{ checkStrictly: true, value: 'id', label: 'text' }"
          >
          </el-cascader>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="infoData.regisDialogVisible = false"
            >取消</el-button
          >
          <el-button
            type="primary"
            @click="handleComRiges"
            :loading="infoData.regisLoading"
            >确定</el-button
          >
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue-demi";
import api from "../../http/apis";
import { ElMessageBox, ElMessage } from "element-plus";
import { useStore } from "vuex";
import { Search } from "@element-plus/icons-vue";
export default {
  setup() {
    const store = useStore();
    const tableData = ref(null);
    const infoData = reactive({
      tableData: [],
      loading: false,
      regisLoading: false,
      pageInfo: {},
      seletectRoleInfo: {},
      roleList: [],
      role: "",
      searchInput: "",
      dialogVisible: false,
      regisDialogVisible: false,
      oldLoginName: "",
      newLoginName: "",
      form: {
        stype: 2,
      },
      regionDataList: [],
    });
    const getTableData = async () => {
      infoData.loading = true;
      const { data } = await api.userApi.queryUser({
        page: infoData.pageInfo.pageIndex,
        rows: infoData.pageInfo.pageSize || 20,
        intId: 1,
        Value: infoData.searchInput,
        sort: "createTime",
      });
      if (data.isSuccessful) {
        infoData.loading = false;
        infoData.tableData = data.resultObj.data;
        infoData.pageInfo = data.resultObj.pagerInfo;
      } else if (data.resultMsg) {
        ElMessage({
          message: data.resultMsg,
          type: "error",
        });
      } else {
        ElMessage({
          message: "请求错误！请重新登录！",
          type: "error",
        });
      }
    };
    getTableData();
    const handleSelect = (selection, row) => {
      if (selection.length > 1) {
        tableData.value.toggleRowSelection(selection[0], false);
        infoData.seletectRoleInfo = row;
        tableData.value.setCurrentRow(row);
      } else if (selection.length == 1) {
        // console.log(selection.length)
        infoData.seletectRoleInfo = row;
        tableData.value.setCurrentRow(row);
      } else if (selection == "") {
        tableData.value.toggleRowSelection(row, true);
        infoData.seletectRoleInfo = row;
      } else {
        infoData.seletectRoleInfo = {};
      }
    };
    const handleTableChange = (currentRow, oldCurrentRow) => {
      if (oldCurrentRow) {
        tableData.value.toggleRowSelection(oldCurrentRow, false);
        handleSelect("", currentRow);
      } else {
        handleSelect("", currentRow);
      }
    };
    const handleOpenRegis = () => {
      infoData.regisDialogVisible = true;
      getRegionList();
    };
    const handleComRiges = async () => {
      infoData.regisLoading = true;
      if (infoData.form.regionId) {
        infoData.form.regionId = infoData.form.regionId.pop();
      }
      const { data } = await api.userApi.regisComs(infoData.form);
      if (data.isSuccessful) {
        ElMessage({
          message: data.resultMsg,
          type: "success",
        });
        infoData.regisLoading = false;
        infoData.regisDialogVisible = false;
        getTableData();
      } else if (data.resultMsg) {
        infoData.regisLoading = false;
        ElMessage({
          message: data.resultMsg,
          type: "error",
        });
      } else {
        infoData.regisLoading = false;
        ElMessage({
          message: data.message,
          type: "error",
        });
      }
    };
    const getRegionList = async () => {
      const { data } = await api.companyApi.getManageToolMenu();
      if (data.isSuccessful) {
        infoData.regionDataList = data.resultObj[0].children;
      } else if (data.resultMsg) {
        ElMessage({
          message: data.resultMsg,
          type: "error",
        });
      } else {
        ElMessage({});
      }
    };
    return {
      infoData,
      getTableData,
      handleSelect,
      handleTableChange,
      tableData,
      handleComRiges,
      getRegionList,
      handleOpenRegis,
    };
  },
  methods: {
    async checkRoleDifined() {
      if (!this.infoData.seletectRoleInfo.id) {
        ElMessage({
          message: "请选择用户后再进行操作！",
          type: "error",
        });
      } else {
        this.$router.push({
          path: "userRole",
          query: {
            id: this.infoData.seletectRoleInfo.id,
          },
        });
      }
    },
    async handleResetPwd() {
      if (!this.infoData.seletectRoleInfo.id) {
        ElMessage({
          message: "请选择用户后再进行操作！",
          type: "error",
        });
      } else {
        ElMessageBox.confirm(
          "确认重置 <" + this.infoData.seletectRoleInfo.nickName + "> 密码？",
          "提示",
          {
            confirmButtonText: "确认",
            cancelButtonText: "取消",
            type: "warning",
          }
        )
          .then(() => {
            this.resetPwd();
          })
          .catch(() => {});
      }
    },
    async resetPwd() {
      console.info("selected info", this.infoData.seletectRoleInfo);

      const { data } = await api.userApi.resetPwd(
        this.infoData.seletectRoleInfo.id
      );
      if (data.isSuccessful) {
        ElMessage({
          message: data.resultMsg,
          type: "success",
        });
        this.getTableData();
      } else if (data.resultMsg) {
        ElMessage({
          message: data.resultMsg,
          type: "error",
        });
      } else {
        ElMessage({});
      }
    },
    handleEditUserN() {
      if (this.infoData.seletectRoleInfo.loginName) {
        this.infoData.oldLoginName = this.infoData.seletectRoleInfo.loginName;
        this.infoData.dialogVisible = true;
      } else {
        ElMessage({
          message: "请选择用户后再进行操作！",
          type: "error",
        });
      }
    },
    async handleSwithSta(userId, sta) {
      // console.log(userId,sta)
      const { data } = await api.userApi.editUserStatus(userId, sta);
      if (data.isSuccessful) {
        ElMessage({
          message: data.resultMsg,
          type: "success",
        });
        this.getTableData();
      } else if (data.resultMsg) {
        ElMessage({
          message: data.resultMsg,
          type: "error",
        });
      } else {
        ElMessage({});
      }
    },
    async handleResetUserName() {
      const { data } = await api.userApi.changeUserName(
        this.infoData.oldLoginName,
        this.infoData.newLoginName
      );
      if (data.isSuccessful) {
        ElMessage({
          message: data.resultMsg,
          type: "success",
        });
        this.infoData.dialogVisible = false;
        this.getTableData();
      } else if (data.resultMsg) {
        ElMessage({
          message: data.resultMsg,
          type: "error",
        });
      } else {
        ElMessage({});
      }
    },
    handleSizeChange(val) {
      this.infoData.pageInfo.pageSize = val;
      this.getTableData();
    },
    handleCurrentChange(val) {
      this.infoData.pageInfo.pageIndex = val;
      this.getTableData();
    },
    handleTableCurrentChange(val) {
      this.infoData.seletectRoleInfo = val;
    },
    dateTrimmer(str) {
      if (str) {
        return str.slice(0, 10) + " " + str.slice(11, 19);
      } else {
        return "无";
      }
    },
    handleClose() {
      this.infoData.dialogVisible = false;
      this.infoData.role = "";
    },
  },
};
</script>

<style scoped lang='scss'>
@use "../../assets/scss/table.scss" as *;
</style>
